import HeaderPortal from "components/portal/header-portal";
import { FormLabel } from "components/form";
import { FormField, FormItem, FormMessage } from "ui/components/form";
import ButtonWithLoading from "@/components/button-with-loading";
import { Form } from "react-crud-form";
import { Input } from "ui/components/input";
import { PermissionControlledInput } from "permissions/components/input";
import React from "react";
import { taskSchema } from "./schema";
import { DatePicker } from "components/date-picker-2";
import TiptapEditor from "components/tiptap-editor";
import { useTaskForm } from "./useTaskForm";
import MultiFileUpload from "ui/components/multi-file-upload";
import EmployeeInput from "components/employee/input";

const TaskForm = () => {

  const { form, requiredFields, handleCreate } = useTaskForm();

  return (
    <Form
      form={form}
      create={handleCreate}
      itemId="+"
      schema={taskSchema}
    >
      {({ isCreating, createItem, isNewItem }) => {
        return (
          <>
            <div className="space-y-6">
              {form.error && (
                <div className="text-red-600 bg-red-50 p-2 rounded">
                  {form.error.message || form.error}
                </div>
              )}

              <FormField
                control={form.control}
                name="title"
                render={({ field }) => (
                  <FormItem>
                    <PermissionControlledInput
                      rule={isNewItem ? "create:*" : "update:*"}
                      collection="tasks"
                      type="form"
                      field={field.name}
                    >
                      <FormLabel required={requiredFields.includes(field.name)}>
                        Title
                      </FormLabel>
                      <Input {...field} />
                    </PermissionControlledInput>
                    <FormMessage />
                  </FormItem>
                )}
              />

              <FormField
                control={form.control}
                name="assignee"
                render={({ field }) => (
                  <FormItem>
                    <PermissionControlledInput
                      rule={isNewItem ? "create:*" : "update:*"}
                      collection="tasks"
                      type="form"
                      field={field.name}
                    >
                      <FormLabel required={requiredFields.includes(field.name)}>
                        Assignee
                      </FormLabel>
                      <EmployeeInput {...field} />
                    </PermissionControlledInput>
                    <FormMessage />
                  </FormItem>
                )}
              />

              <FormField
                control={form.control}
                name="description"
                render={({ field }) => (
                  <FormItem>
                    <PermissionControlledInput
                      rule={isNewItem ? "create:*" : "update:*"}
                      collection="tasks"
                      type="form"
                      field={field.name}
                    >
                      <FormLabel required={requiredFields.includes(field.name)}>
                        Description
                      </FormLabel>
                      <TiptapEditor {...field} className="min-h-32" />
                    </PermissionControlledInput>
                    <FormMessage />
                  </FormItem>
                )}
              />

              <FormField
                control={form.control}
                name="attachments"
                render={({ field }) => (
                  <FormItem>
                    <PermissionControlledInput
                      rule={isNewItem ? "create:*" : "update:*"}
                      collection="tasks"
                      type="form"
                      field={field.name}
                      showWhenDisabled={false}
                    >
                      <FormLabel required={requiredFields.includes(field.name)}>
                        Upload Files
                      </FormLabel>
                      <MultiFileUpload
                        value={field.value || []}
                        onChange={field.onChange}
                        accept="image/*"
                        maxFiles={10}
                        className="w-full"
                      />
                    </PermissionControlledInput>
                    <FormMessage />
                  </FormItem>
                )}
              />

              <FormField
                control={form.control}
                name="due_date"
                render={({ field }) => (
                  <FormItem>
                    <PermissionControlledInput
                      rule={isNewItem ? "create:*" : "update:*"}
                      collection="tasks"
                      field={field.name}
                      type="form"
                      showWhenDisabled={false}
                    >
                      <FormLabel required={requiredFields.includes(field.name)}>
                        Due Date
                      </FormLabel>
                      <DatePicker {...field} />
                    </PermissionControlledInput>
                    <FormMessage />
                  </FormItem>
                )}
              />

              <HeaderPortal>
                <ButtonWithLoading
                  variant="default"
                  isLoading={isCreating}
                  onClick={createItem}
                >
                  Save
                </ButtonWithLoading>
              </HeaderPortal>
            </div>
          </>
        );
      }}
    </Form>
  );
};

export default TaskForm;
